import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instanceistwsh6nfjqm as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.SIZE_1 = 8192;
        this.SHARE_MINIMUM_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.pos_1 = 0;
  _this__u8e3s4.limit_1 = 0;
  _this__u8e3s4.shared_1 = false;
  _this__u8e3s4.owner_1 = false;
  _this__u8e3s4.next_1 = null;
  _this__u8e3s4.prev_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static new_okio_Segment_n914wl_k$() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.data_1 = new Int8Array(8192);
        $this.owner_1 = true;
        $this.shared_1 = false;
        return $this;
      }
      static new_okio_Segment_4qrled_k$(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.data_1 = data;
        $this.pos_1 = pos;
        $this.limit_1 = limit;
        $this.shared_1 = shared;
        $this.owner_1 = owner;
        return $this;
      }
      sharedCopy_timhza_k$() {
        this.shared_1 = true;
        return Segment().new_okio_Segment_4qrled_k$(this.data_1, this.pos_1, this.limit_1, true, false);
      }
      pop_2dsh_k$() {
        var result = !(this.next_1 === this) ? this.next_1 : null;
        ensureNotNull(this.prev_1).next_1 = this.next_1;
        ensureNotNull(this.next_1).prev_1 = this.prev_1;
        this.next_1 = null;
        this.prev_1 = null;
        return result;
      }
      push_wd62e0_k$(segment) {
        segment.prev_1 = this;
        segment.next_1 = this.next_1;
        ensureNotNull(this.next_1).prev_1 = segment;
        this.next_1 = segment;
        return segment;
      }
      split_cz4av2_k$(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.limit_1 - this.pos_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.sharedCopy_timhza_k$();
        } else {
          prefix = SegmentPool_instance.take_2451j_k$();
          var tmp0 = this.data_1;
          var tmp2 = prefix.data_1;
          var tmp5 = this.pos_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.pos_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.limit_1 = prefix.pos_1 + byteCount | 0;
        this.pos_1 = this.pos_1 + byteCount | 0;
        ensureNotNull(this.prev_1).push_wd62e0_k$(prefix);
        return prefix;
      }
      compact_dawvql_k$() {
        // Inline function 'kotlin.check' call
        if (!!(this.prev_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if (!ensureNotNull(this.prev_1).owner_1)
          return Unit_instance;
        var byteCount = this.limit_1 - this.pos_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.prev_1).limit_1 | 0) + (ensureNotNull(this.prev_1).shared_1 ? 0 : ensureNotNull(this.prev_1).pos_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.writeTo_yxwz0w_k$(ensureNotNull(this.prev_1), byteCount);
        this.pop_2dsh_k$();
        SegmentPool_instance.recycle_ipeoxr_k$(this);
      }
      writeTo_yxwz0w_k$(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.owner_1) {
          var message = 'only owner can write';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if ((sink.limit_1 + byteCount | 0) > 8192) {
          if (sink.shared_1)
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_pv5o3f_k$();
          if (((sink.limit_1 + byteCount | 0) - sink.pos_1 | 0) > 8192)
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_pv5o3f_k$();
          var tmp0 = sink.data_1;
          var tmp2 = sink.data_1;
          var tmp5 = sink.pos_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.limit_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.limit_1 = sink.limit_1 - sink.pos_1 | 0;
          sink.pos_1 = 0;
        }
        var tmp0_0 = this.data_1;
        var tmp2_0 = sink.data_1;
        var tmp4 = sink.limit_1;
        var tmp6 = this.pos_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.pos_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.limit_1 = sink.limit_1 + byteCount | 0;
        this.pos_1 = this.pos_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.new_okio_Segment_n914wl_k$);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
